export default "__VITE_ASSET__72s1zyJP__"